import { render } from "./sr-drag.vue?vue&type=template&id=f2176408&scoped=true"
import script from "./sr-drag.vue?vue&type=script&lang=js"
export * from "./sr-drag.vue?vue&type=script&lang=js"

import "./sr-drag.vue?vue&type=style&index=0&id=f2176408&scoped=true&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "/data/.jenkins/workspace/WEB-samp-webapp-HK/common/temp/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2176408"]])

export default __exports__